import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import BodyText from "../../../components/typography/Body";
import colors from "../../../utils/colors";
import SearchBar from "../../../components/ui/searchBar";
import Dropdown from "../../../components/ui/dropdown";
import Button from "../../../components/ui/button";
import { add } from "../../../assets";

interface IProps {
  setCategory: React.Dispatch<React.SetStateAction<string>>;
  category: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  openModal?: any;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

const PatientsUtils = ({
  openModal,
  setSearch,
  setCategory,
  setPage,
}: IProps) => {
  return (
    <Box>
      <Flex
        justifyContent="space-between"
        p="16px"
        borderTopRadius="8px"
        borderBottom={`1px solid ${colors.grey}`}
      >
        <BodyText size="s" fontWeight={700} fontSize="14px" color={colors.dark}>
          Patients
        </BodyText>
      </Flex>

      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        gap={{ base: 4, md: 0 }}
        p="16px"
        borderBottom={`1px solid ${colors.grey}`}
      >
        <Flex gap="20px" direction={{ base: "column", sm: "row" }} flex="1">
          <SearchBar
            className="max-w-[300px] w-full"
            height="40px"
            width="100%"
            handleChange={(e) => {
              setSearch(e);
              setPage(1);
            }}
            placeholderText="Search for patients by name"
          />

          <Dropdown
            onSelect={(val) => setCategory(val)}
            options={["All", "High Risk", "Low Risk", "Medium Risk"]}
            className="!h-[40px] w-full sm:w-[200px] !pl-[15px]"
            valueFont="600"
            placeholder="Category"
            inputStyles="!font-[400]"
          />
        </Flex>

        <Box mt={{ base: "12px", md: "0" }}>
          <Button
            text="Add New Patient"
            icon={add}
            theme="primary"
            size="md"
            className="rounded-md h-[40px] text-sm w-full sm:w-[240px]"
            onClick={openModal}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default PatientsUtils;
